module.exports = __webpack_public_path__ + "static/weather-mobile-dark-plp-6667e80ba08ccf8c1b5e0acc8ac639c8.png";